enum ISuppliServiceType {
  None = 0, // eslint-disable-line no-unused-vars
  Core = 1, // eslint-disable-line no-unused-vars
  eRFx = 2, // eslint-disable-line no-unused-vars
  Billing = 3, // eslint-disable-line no-unused-vars
  Contracting = 4, // eslint-disable-line no-unused-vars
  Messaging = 5, // eslint-disable-line no-unused-vars
  ERPIntergration = 6 // eslint-disable-line no-unused-vars
}

export const iSuppliServiceTypeToString = (value: ISuppliServiceType) => {
  switch (value) {
    case ISuppliServiceType.Core:
      return "Core";
    case ISuppliServiceType.eRFx:
      return "eRFx";
    case ISuppliServiceType.Billing:
      return "Billing";
    case ISuppliServiceType.Contracting:
      return "Contracting";
    case ISuppliServiceType.Messaging:
      return "Messaging";
    case ISuppliServiceType.ERPIntergration:
      return "ERP Integration";
    default:
      return "";
  }
};

export const ISuppliServiceTypeOptions = () => {
  const options = Object.values(ISuppliServiceType)
    .filter((value) => typeof value === "number" && value !== ISuppliServiceType.None)
    .map((value) => value as ISuppliServiceType)
    .map((value) => ({
      display: iSuppliServiceTypeToString(value),
      value,
    }))
    .sort((a, b) => (a.display > b.display ? 1 : -1));
  return options;
};

export default ISuppliServiceType;
